export const FORECAST_EXPERIENCE_PATH = "/revenue-intelligence/forecast-v2";
export const FORECAST_COMPARISON_DAYS = 14;

export const FORECAST_COPY = {
  title: "Forecast",
  expected: "Expected outcome",
  crm: "CRM stage-weighted forecast",
  composition: "Forecast composition",
  won: "Already won",
  existing: "Expected from existing pipeline",
  future: "Expected from future pipeline",
  gap: "To reach target",
  movement: `Change in forecast · last ${FORECAST_COMPARISON_DAYS} days`,
  movementScope: "Today's owner, team and pipeline selection is applied to both dates.",
  movementMethod: "Start is reconstructed backwards from today's forecast using verified changes, today's Deal amounts and today's filter selection. Unavailable history is not assigned a change.",
  outcomes: "Deals by outcome",
  scenarios: "What could change the outcome?",
  report: "Add to report",
  will: "Will close",
  inPlay: "In play",
  wont: "Won’t close",
  outcomePopulation: "Open Deals with a CRM close date in this period.",
  predictions: "Predictions for the selected period, not guarantees. Deals without an assessed probability are not grouped.",
  futureMethod: "Historical planning estimate using this customer's creation pace, seasonality and observed time to win. Includes only future opportunities that could win within the selected period. It is added once; insufficient history is not treated as zero.",
  incomplete: "Future pipeline cannot yet be estimated for this selection. The amount shown covers already won and existing pipeline.",
  historyMissing: `Comparable forecast amounts from ${FORECAST_COMPARISON_DAYS} days ago are not yet available.`,
  delayed: "More than 10% chance of winning within the model's 53-week horizon, less than 10% within this period, with timing pointing later. This does not predict a certain later win.",
  lowWin: "Less than 10% chance of winning across the model's 53-week horizon. This is a prediction, not a recorded loss.",
  secureOpportunity: "Secure this period",
  accelerateOpportunity: "Bring forward from next quarter",
} as const;

export const FORECAST_SNAPSHOT_MOVEMENT_COPY: Record<string, string> = {
  new_deals: "Deals created after the starting snapshot. Only their selected-period forecast contribution is added.",
  closed_won: "Recorded won revenue minus the contribution already included at the start. Uses the same selected calendar period.",
  closed_lost: "Removes the selected-period contribution previously included for Deals now recorded lost.",
  moved_in: "Contribution entered the selected period between the recorded dates. Today's filter selection is applied to both dates.",
  moved_out: "Contribution left the selected period between the recorded dates. Today's filter selection is applied to both dates.",
  improved_outlook: "The recorded selected-period contribution increased. This does not attribute the change to individual signals.",
  weakened_outlook: "The recorded selected-period contribution decreased. This does not attribute the change to individual signals.",
  "future-pipeline": "Change in the separate future-pipeline estimate, using the history available at each recorded date. Included once.",
  unclassified: "Includes changed forecast coverage or source, and adjustments to recorded outcomes. These are not labelled sales progress.",
};

export const FORECAST_RECONSTRUCTED_MOVEMENT_COPY: Record<string, string> = {
  ...FORECAST_SNAPSHOT_MOVEMENT_COPY,
  start: FORECAST_COPY.movementMethod,
  current: "The same Expected outcome shown above, including already won, existing pipeline and available future pipeline.",
  new_deals: "Deals created after the earlier assessment. Only their current selected-period contribution is added.",
  improved_outlook: "The selected-period contribution increased, using today's Deal amount at both dates. No causal allocation to individual signals.",
  weakened_outlook: "The selected-period contribution decreased, using today's Deal amount at both dates. No causal allocation to individual signals.",
  "future-pipeline": "Change in the existing historical planning estimate, reconstructed at the earlier date with today's amounts. Included only when both dates have comparable inputs.",
  unclassified: "Verified changes in model coverage or recorded closed outcomes. Unknown historical amounts are not assigned to this bar.",
};
